import { EvalFunction, MathNode } from '@spazious/mathjs';

import { Scope } from './types.js';
import { formatPath, parse } from './utils.js';

/**
 * Creates a expression that can be evaluated in a scope
 * with the parsed expression
 */
export class ScopeExpression {
  name: string;
  expr: string;
  node: MathNode;
  scope: Scope;
  path: string;
  fallback: number = 0;
  compiled: EvalFunction;
  constructor(name: string, expr: string, scope: Scope) {
    this.name = name;
    this.expr = expr;
    this.node = parse(expr);
    this.compiled = this.node.compile();
    this.scope = scope;
    this.path = formatPath(scope.name, name);
  }

  evaluate() {
    return this.compiled.evaluate(this.scope);
  }

  toString() {
    return this.node.toString();
  }

  toTex() {
    return this.node.toTex();
  }

  toHTML() {
    return this.node.toHTML();
  }
}
